<template>
<div id="container" class="active spiele_ausmalen">
  <top-menu />
  <top-logo />
  <stoppuhr />
  <lautsprecher />
    <copyright />
    <div class="fullscreen_background z1 active">
        <img src="/static/assets/spiele_memory/Hintergrund_2860.png" />
    </div>

  <div class="z2 active text"><img src="/static/assets/spiele_ausmalen/spiele_ausmalen_text.png"></div>
  <div class="z50 active textplaybutton pointer" @click="starttextplay"><img src="/static/assets/alle/Play_Button.png"/></div>
  <a href="/static/assets/alle/Hudu_Hugidubies_Zauberer_Dubix.pdf" target="_blank" class="z5"><div class="z2 active download download_animation"><!-- <img src="/static/assets/spiele_ausmalen/spiele_ausmalen_download.png">--></div></a>
  <div class="malen_slider active z3">
    <router-link to="/spieledownloads_gigi_04" tag="div" class="z3 active pfeil_links pointer"><img src="/static/assets/spiele_ausmalen/spiele_ausmalen_Pfeil_links.png"></router-link>
    <div class="z3 active figur"><img src="/static/assets/spiele_ausmalen/dubix1.png" border="0"></div>
    <router-link to="/spieledownloads_hugi_04" tag="div"  class="z3 active pfeil_rechts pointer"><img src="/static/assets/spiele_ausmalen/spiele_ausmalen_Pfeil_rechts.png"></router-link>
  </div>
  <div class="z14 active front"><img src="/static/assets/spiele_ausmalen/spiele_ausmalen_stifte.png"></div>
</div>
</template>

<script>
/* eslint no-trailing-spaces: "off" */
import Topmenu from '@/components/Topmenu.vue'
import Toplogo from '@/components/Toplogo.vue'
import Stoppuhr from '@/components/Stoppuhr.vue'
import Lautsprecher from '@/components/Lautsprecher.vue'
import Copyright from '@/components/Copyright.vue'

window.$ = window.jQuery = require('jquery')

export default {
  name: 'Spieledownloads_dubix_02',
  data () {
    return {
      who: 'Spieledownloads_dubix_02'
    }
  },
  components: {
    'top-menu': Topmenu,
    'top-logo': Toplogo,
    'stoppuhr': Stoppuhr,
    'lautsprecher': Lautsprecher,
    'copyright': Copyright
  },
  methods:{
    starttextplay () {
      console.log('starttextplay')
        try {
            window.currentAudioX.pause()
            window.currentAudioX.currentTime = 0
            window.currentAudioX = null
        } catch (e) {
            console.log('pause geht nicht')
        }
        window.currentAudioX = new Audio('/static/assets/sounds/03b_Ausmal-Seite/Sprache/Hugidubies_Ausmalseite.mp3')
        window.currentAudioX.muted = muted
        window.currentAudioX.play()
    }
  },
  mounted () {
    this.$ga.page(this.$router)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {margin:0; padding:0;}

/* Z-Index - Level */

.z1{z-index:10;}
.z2{z-index:20;}
.z3{z-index:30;}
.z4{z-index:40;}
.z5{z-index:50;}
.z6{z-index:60;}
.z7{z-index:70;}
.z8{z-index:80;}
.z9{z-index:90;}
.z10{z-index:100;}
.z11{z-index:110;}
.z12{z-index:120;}
.z13{z-index:130;}
.z14{z-index:140;}
.z15{z-index:150;}
.z16{z-index:160;}
.z17{z-index:170;}
.z18{z-index:180;}
.z19{z-index:190;}
.z20{z-index:200;}
.z21{z-index:210;}
.z22{z-index:220;}
.z23{z-index:230;}
.z24{z-index:240;}
.z25{z-index:250;}
.z26{z-index:260;}
.z27{z-index:270;}
.z28{z-index:280;}
.z29{z-index:290;}
.z30{z-index:300;}
.z31{z-index:310;}
.z32{z-index:320;}
.z33{z-index:330;}
.z34{z-index:340;}
.z35{z-index:350;}
.z36{z-index:360;}
.z37{z-index:370;}
.z38{z-index:380;}
.z39{z-index:390;}
.z40{z-index:400;}
.z41{z-index:410;}
.z42{z-index:420;}
.z43{z-index:430;}
.z44{z-index:440;}
.z45{z-index:450;}
.z46{z-index:460;}
.z47{z-index:470;}
.z48{z-index:480;}
.z49{z-index:490;}
.z50{z-index:500;}
/* SPIELE */
.spiele_start .memo_01 {
    bottom: 14.5%;
    left: 21%;
}
.spiele_start .memo_02 {
    bottom: 30%;
    left: 17%;
}
.spiele_start .malen_01 {
    bottom: 14.5%;
    right: 22.5%;
}
.spiele_start .malen_02 {
    bottom: 30%;
    left: 57%;
}
.spiele_start #menulayer {
    top: 3.5%;
    right: 22%;
}
.spiele_start div {
    position: absolute;
    width: 286px;
        }
.spiele_start div{display:none;}
.spiele_start .active{display:block !important;}
.spiele_start #spiele_start{position: absolute; width: 1920px; height: 1080px;}

/* SPIELE ausmalen*/
.spiele_ausmalen .malen_slider {
    height: 100%;
    width: 100%;
}
.spiele_ausmalen .pfeil_links {
    left: 35%;
    bottom: 41%;
}
.spiele_ausmalen .pfeil_rechts {
    right: 8%;
    bottom: 41%;
}
.spiele_ausmalen .copyright {
    width: 500px !important;
}
.spiele_ausmalen .figur {
    left: 39.5%;
    bottom: 4%;
}
.spiele_ausmalen .text {
    bottom: 41%;
    left: 14%;
}
.spiele_ausmalen .download {
    bottom: 19%;
    left: 19%;
    width: 136px;
}
.spiele_ausmalen .front {
    bottom: -245px;
    right: 26%;
}

.spiele_ausmalen #menulayer {
    top: 3.5%;
    right: 22%;
}
.spiele_ausmalen div {
    position: absolute;
    width: 286px;
}
.spiele_ausmalen div{display:none;}
.spiele_ausmalen .active{display:block !important;}
.spiele_ausmalen #spiele_ausmalen{position: absolute; width: 1920px; height: 1080px;}

/* SPIELE memory*/
.spiele_memory .malen_slider {
    height: 100%;
    width: 100%;
}
.spiele_memory .cards_auswahl {
    height: 100%;
    width: 100%;
}

.cards_auswahl img {
    box-shadow: 4px 4px 10px rgba(0,0,0,0.5);
}
.karte_top {
    bottom: 260px;
    left: 14%;
}
.karte_bottom_01 {
    left: 14%;
    bottom: 14%;
}
.karte_bottom_02 {
    left: 19.5%;
    bottom: 14%;
}
.karte_bottom_03 {
    left: 25.8%;
    bottom: 14%;
}

.cards_memory {
    width: 50%;
    height: 30%;
}
.cards_memory {
    width: 50%;
    height: 70%;
    bottom: 0;
    right: 14.5%;
    border: 0px solid;
}
.spiele_memory .karte {
    float: left;
    position: relative;
    margin-right: 4%;
    margin-bottom: 3%;
}
.spiele_memory .karte img {
    box-shadow: 4px 4px 10px rgba(0,0,0,0.5);
}
.spiele_memory .text {
    bottom: 80.5%;
    right: 26%;
}
.spiele_memory .download {
    bottom: 19%;
    left: 19%;
}
.spiele_memory .front {
    bottom: -245px;
    right: 26%;
}

.spiele_memory #menulayer {
    top: 3.5%;
    right: 22%;
}
.spiele_memory div {
    position: absolute;
        }.download_animation {
  width: 136px;
  height: 152px;
  background: url('/static/assets/spiele_ausmalen/Download_animation.png') top center;
  animation-delay: 2s;
  animation: play_download 1s steps(5) infinite;
  transform: scale(1);
  margin-top:-25px;
}

@keyframes play_download {
    100% { background-position: 0 -760px; }
}

.spiele_memory div{display:none;}
.spiele_memory .active{display:block !important;}
.spiele_memory #spiele_memory{position: absolute; width: 1920px; height: 1080px;}

.logo, .menu, .lautsprecher, .stoppuhr {display:inherit !important;}
 
.download_animation {
  width: 136px;
  height: 152px;
  background: url('/static/assets/spiele_ausmalen/Download_animation.png') top center;
  animation-delay: 2s;
  animation: play_download 1s steps(5) infinite;
  transform: scale(1);
  margin-top:-25px;
}

@keyframes play_download {
    100% { background-position: 0 -760px; }
}
a.z5 {
    width: 150px;
    height: 150px;
    position: absolute;
    top: 730px;
    left: 350px;
}

.z50.active.textplaybutton.pointer {
    top: 241px;
    left: 398px;
}
.z50.active.textplaybutton.pointer img {
    width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/Spieledownloads_dubix_04.vue